import { FormlyModule } from '@ngx-formly/core';
import { FormlyMatFormFieldModule } from '@ngx-formly/material/form-field';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';

import { SnSliderFormField } from './components/field-type/slider.form-field';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatSliderModule,
    // Formly
    FormlyMatFormFieldModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'slider',
          component: SnSliderFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
  declarations: [SnSliderFormField],
})
export class SnFormSliderModule {}
